module.exports = __webpack_public_path__ + "img/LiveEvent.b91ba27d.svg";